import type { CommissionActivityEventNode } from "../history/types";

export const commissionActivityEventFixtures: CommissionActivityEventNode[] = [
  {
    id: "commission-activity-1",
    entityType: "INGEST_BATCH",
    entityId: "commission-ingest-batch-confirmed",
    eventType: "CONFIRMED",
    description: "Ingest batch confirmed — 1 line posted to ledger.",
    actorDisplayName: "Finance Operator",
    occurredAt: "2026-02-01T10:15:00Z"
  },
  {
    id: "commission-activity-2",
    entityType: "FUNDING_BATCH",
    entityId: "commission-funding-batch-funded",
    eventType: "MARK_PAID",
    description: "Sponsor payment recorded for Acme Golf Sponsors batch.",
    actorDisplayName: "Finance Operator",
    occurredAt: "2026-02-28T14:00:00Z"
  },
  {
    id: "commission-activity-3",
    entityType: "FUNDING_BATCH",
    entityId: "commission-funding-batch-invoiced",
    eventType: "ISSUED",
    description: "Invoice issued to Acme Golf Sponsors (WD-INV-2026-0142).",
    actorDisplayName: "Finance Operator",
    occurredAt: "2026-03-12T09:30:00Z"
  },
  {
    id: "commission-activity-4",
    entityType: "RELEASE_BATCH",
    entityId: "commission-release-batch-exported",
    eventType: "EXPORTED",
    description: "Release exported — 2 payout runs, $3,500.00 total.",
    actorDisplayName: "Finance Operator",
    occurredAt: "2026-03-18T16:45:00Z"
  },
  {
    id: "commission-activity-5",
    entityType: "COMMISSION_LINE",
    entityId: "commission-line-3",
    eventType: "ELIGIBILITY_RECOMPUTED",
    description: "Line marked payable after sponsor funding received.",
    actorDisplayName: "System",
    occurredAt: "2026-02-28T14:05:00Z"
  }
];
